import type { ClientErrorKind, ClientErrorReport } from '@akrababul/shared';
import { CURRENT_HASH_VERSION, HASH_VERSIONS } from '@akrababul/shared';

function buildReport(kind: ClientErrorKind, err: unknown, context: Record<string, string | number | boolean>): ClientErrorReport {
  const nav = navigator as Navigator & { deviceMemory?: number; userAgentData?: { platform?: string } };
  const body: ClientErrorReport = {
    kind, message: err instanceof Error ? err.message : String(err),
    userAgent: navigator.userAgent.slice(0, 500),
    platform: nav.userAgentData?.platform ?? navigator.platform,
    wasmSupported: typeof WebAssembly === 'object',
    hashVersion: CURRENT_HASH_VERSION, hashParams: { ...HASH_VERSIONS[CURRENT_HASH_VERSION]! }, context,
  };
  if (err instanceof Error && err.stack) body.stack = err.stack.slice(0, 2000);
  if (nav.deviceMemory !== undefined) body.deviceMemory = nav.deviceMemory;
  if (navigator.hardwareConcurrency) body.cores = navigator.hardwareConcurrency;
  return body;
}

/** Raporu sunucuya gönderir ve başarı durumunu döndürür; hiçbir zaman fırlatmaz. Kayıt metni veya kişisel veri içermez. */
export async function sendReport(kind: ClientErrorKind, err: unknown, context: Record<string, string | number | boolean> = {}): Promise<boolean> {
  try {
    const res = await fetch('/api/client-error', {
      method: 'POST', credentials: 'same-origin', headers: { 'content-type': 'application/json' },
      body: JSON.stringify(buildReport(kind, err, context)), keepalive: true,
    });
    return res.ok;
  } catch { return false; }
}

/** İstemci hatasını sunucuya bildirir; hiçbir zaman fırlatmaz, akışı bloklamaz. Kayıt metni veya kişisel veri içermez. */
export function reportError(kind: ClientErrorKind, err: unknown, context: Record<string, string | number | boolean> = {}): void {
  void sendReport(kind, err, context);
}
